import React from "react";
import { Button } from 'primereact/button';
import * as warn from "../../../components/Loading/lottiefiles/warn.json";
import Lottie from "react-lottie";
import { useHistory } from "react-router-dom";

const loadOption = {
    loop: true,
    autoplay: true,
    animationData: warn.default,
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
    }
};
export default function P100Overview({ dataDashboard, onClickPendingOrder, onClickPendingRequest, countTimer, onRefreshClick, loadingRefresh }) {

    const history = useHistory();
    return (
        <div className="layout-dashboard">
            <Button
                label={`${countTimer}s.`}
                icon="pi pi-refresh"
                className="p-button-rounded p-button-outlined"
                style={{ position: 'absolute', right: 20, marginTop: '-40px' }}
                onClick={() => onRefreshClick()}
            />
            <div className="p-grid" style={{ marginTop: '8px' }}>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item1 cursor-mo"
                        onClick={() => { history.push('/109') }}
                    >
                        <i className="overview-icon fas fa-file-contract"></i>
                        {loadingRefresh === true ?
                            <div className="overview-numbers"><i className="pi pi-spin pi-spinner" style={{ 'fontSize': '40px' }}></i></div>
                            :
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.totalContract : '-'}</div>
                        }
                        <div className="overview-subinfo">จำนวนสัญญา/เส้นทาง</div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item5 cursor-mo"
                        onClick={() => onClickPendingOrder()}
                    >
                        {
                            dataDashboard.alarmPendingRequest === "Y" ?
                                <i className={`overview-icon`}><Lottie options={loadOption} height={80} width={80} /></i>
                                :
                                <i className="overview-icon fas fa-file-alt"></i>
                        }
                        {/* <i className={"overview-icon fas " + (dataDashboard.alarmPendingRequest === 'Y' ? 'fa-bell noti-alert' : 'fa-file-alt')}></i> */}

                        {loadingRefresh === true ?
                            <div className="overview-numbers"><i className="pi pi-spin pi-spinner" style={{ 'fontSize': '40px' }}></i></div>
                            :
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.totalPendingRequest : '-'}</div>
                        }
                        <div className="overview-subinfo">ใบแจ้งฯรออนุมัติ</div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item8 cursor-mo"
                        onClick={() => { history.push('/107') }}
                    >
                        {
                            dataDashboard.alarmPendingOrder === "Y" ?
                                <i className={`overview-icon`}><Lottie options={loadOption} height={80} width={80} /></i>
                                :
                                <i className="overview-icon fas fa-file-alt"></i>
                        }
                        {/* <i className={"overview-icon fas " + (dataDashboard.alarmPendingRequest === 'Y' ? 'fa-bell noti-alert' : 'fa-paste')}></i> */}

                        {loadingRefresh === true ?
                            <div className="overview-numbers"><i className="pi pi-spin pi-spinner" style={{ 'fontSize': '40px' }}></i></div>
                            :
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.totalPendingOrder : '-'}</div>
                        }
                        <div className="overview-subinfo">งานสั่งการเฉพาะอย่างคงค้าง</div>
                    </div>
                </div>
                <div className="p-col-12 p-lg-6 p-xl-3">
                    <div className="overview-box item7 cursor-mo"
                        onClick={() => onClickPendingRequest()}
                    >
                        {
                            dataDashboard.alarmUnreportRequest === "Y" ?
                                <i className={`overview-icon`}><Lottie options={loadOption} height={80} width={80} /></i>
                                :
                                <i className="overview-icon fas fa-file-alt"></i>
                        }
                        {/* <i className={"overview-icon fas " + (dataDashboard.alarmPendingRequest === 'Y' ? 'fa-bell noti-alert' : 'fa-file-signature')}></i> */}

                        {loadingRefresh === true ?
                            <div className="overview-numbers"><i className="pi pi-spin pi-spinner" style={{ 'fontSize': '40px' }}></i></div>
                            :
                            <div className="overview-numbers">{dataDashboard ? dataDashboard.totalUnreportRequest : '-'}</div>
                        }
                        <div className="overview-subinfo">ใบแจ้งฯยังไม่รายงานผล</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
